module.exports = __webpack_public_path__ + "img/reports.2706e3c9.png";